define('CustomMyAccountMenu'
,   ['MyAccountMenu']
,   function (MyAccountMenu)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var menu = SC && SC.isDevelopment ? MyAccountMenu.MyAccountMenu.getInstance() : MyAccountMenu.getInstance();
			
			if(menu){
				menu.removeSubEntry("balance");
				menu.removeSubEntry("invoices");
				menu.removeSubEntry("quotes");
			}

		}
	};
});
